export default __webpack_public_path__ + "static/media/yes.af56c355.mp3";